<template>

<div class="wireframe">
    <div class="wireframe__header">
      <p class="overline">{{ title }}</p>
    
      <div
        class="list-group-item item relative"
        v-for="(element, index) in items"
        :key="`${titlelc}-${getTime()}-${index}`"
      >
        <h3
          v-if="element.type == 'headline'"
          class="wireframe__headline"
        >
        <div v-html="element.title"></div>
        </h3>

        <div
          class="wireframe__button"
          v-else-if="element.type == 'button'"
        >
          <div v-html="element.title"></div>
        </div>
        <div v-else class="wireframe__content">
          <div v-html="element.title"></div>
        </div>
        
      </div>
    </div>
</div>
</template>

<script>

export default {
  name: "ResultsPahges",
  data() {
    return {
      doc: null
    };
  },
  props: {
    items: Array,
    title: String
  },
computed: {
    titlelc() {
      return this.title.toLowerCase();
    },
  },
  methods: {
    getTime() {
      return Math.round(new Date().getTime() / 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
    .wireframe {
        width: 100%;
    }
</style>